module.exports = __webpack_public_path__ + "img/AI数智化协同管理ico.7e596fb5.png";